module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n.table-responsive .form-control{\r\n    width:150px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Increments/increment-list-authorization/incr-list-auth/incr-list-auth.component.css
// module id = ./src/app/hrms/Increments/increment-list-authorization/incr-list-auth/incr-list-auth.component.css
// module chunks = main